import injectWidget from './injectWidget'

export default injectWidget
